<template lang="pug">
//div(:key="$route.hash", class="py-8 px-4 sm:px-8 font-sans view tw-view")
page-view(:title="$t('payout.payout')" backLink="/commerce/payouts" backText="Back to payouts")
  template(v-slot:id)
    id(:id="id")
  //page-header(
    :id="id"
    :breadcrumbs=`[{path: '/commerce', title: 'commerce.title'}, {path: '/commerce/payouts', title: 'commerce.payouts'}]`
    icon='M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4'
    )
    | {{ $t('payout.payout') }}

  div
    template(v-if="fetchingPayouts")
      .container.my-20.text-center.text-gray-500
        i.mdi.mdi-loading.mdi-spin
    template(v-else)
      basic-panel(v-if="!data")
        alert-error(displaySupport="true")
          | {{ $t('payout.load_error') }}

      basic-panel(v-else)
        template(v-slot:header)
          .flex.flex-col
            .p-b-2.font-medium.text-gray-600 {{ $t('payout.payout') }}
            div
              span.text-xl.font-medium {{ data.payout.amount | amount(data.payout.currency) }}&nbsp;
              span.text-xl.font-medium.p-r-2.uppercase {{data.payout.currency}}
              Tag(:text="data.payout.status", :class="{'capitalize': true}")
        dl.py-4
          div(:class="'sm:grid sm:grid-cols-3 sm:gap-4'")
            dt.text-sm.leading-5.font-medium.text-gray-500.p-l-4 {{ $t('payout.date_paid') }}
            dd(class="p-l-4 sm:p-l-0 mt-1 sm:mt-0 text-sm leading-5 sm:col-span-2 text-gray-900 capitalize") {{ data.payout.arrival_date | friendly_short_date }}
          div(:class="'mt-8 sm:grid sm:mt-5 sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5'")
            dt.text-sm.leading-5.font-medium.text-gray-500.p-l-4 {{ $t('payout.amount') }}
            dd(class="p-l-4 sm:p-l-0 mt-1 sm:mt-0 text-sm leading-5 sm:col-span-2 text-gray-900") {{ data.payout.amount | amount(data.payout.currency) }}
          div(:class="'mt-8 sm:grid sm:mt-5 sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5'")
            dt.text-sm.leading-5.font-medium.text-gray-500.p-l-4 {{ $t('payout.bank') }}
            dd(class="p-l-4 sm:p-l-0 mt-1 sm:mt-0 text-sm leading-5 sm:col-span-2 text-gray-900") {{`${data.payout.bank_name} •••• ${data.payout.bank_last4}`}}
          div(class="mt-8 sm:grid sm:mt-5 sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5", v-if="(data.payout.status === 'paid' || data.payout.status === 'open') && data.payout.invoice")
            dt.text-sm.leading-5.font-medium.text-gray-500.p-l-4 {{ $t('payout.invoice') }}
            dd(class="p-l-4 sm:p-l-0 mt-1 sm:mt-0 text-sm leading-5 sm:col-span-2 text-gray-900" @click="download(data.payout.invoice.id)"): span.link.underline {{ $t('payout.download') }}

    template(v-if="data")
      AccountSummary(v-for="account in data.account_summary", :acc="account", :payout="data.payout", :key="account.id")

</template>
<script>
import Tag from '@/components/tag.vue';
import AccountSummary from '@/components/payout-account-summary.vue';

export default {
  data() {
    return {
      data: null,
      fetchingPayouts: true,
      breadcrumbs: [{
        path: '/commerce',
        title: 'commerce.title',
      },
      {
        path: '/commerce/payouts',
        title: 'commerce.payouts',
      }],
    };
  },
  mounted() {
    this.fetchPayouts();
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    Tag,
    AccountSummary,
  },
  methods: {
    async fetchPayouts() {
      this.fetchingPayouts = true;
      const payouts = await ovpFetch(`/payouts/${this.id}`).catch(() => false);
      this.fetchingPayouts = false;
      if (!payouts) {
        this.data = null;
        return;
      }
      this.data = payouts.data;
    },
    async download(invoice) {
      const response = await ovpFetch(`https://api.streamify.io/payouts/invoice/${invoice}/pdf`, {
        responseType: 'blob',
      });
      const download = document.createElement('a');
      download.style.display = 'none';
      download.href = URL.createObjectURL(response.data);
      download.download = invoice;
      document.body.appendChild(download);
      download.click();
      setTimeout(() => {
        download.parentElement.removeChild(download);
      }, 1000);
    },
  },
};
</script>

<style lang="sass" scoped>

@import '../variables.sass'

.payout
  .header
    padding: 15px 10px
    .title
      font-size: 16px
  h1
    font-size: 20px
    line-height: 20px
    font-weight: 500
    span
      padding-right: 5px
      &.currency
        text-transform: uppercase
    .tag
      margin-left: 10px
      margin-top: 0px
  h2
    line-height: 18px
    font-weight: 500
    border-bottom: 1px solid #ccc
  .description-list-label
    flex: 0 0 20%
    padding: 12px 10px
    color: rgba(107,114,128, 1)
  .description-list-item
    padding: 12px 10px

table
  border-spacing: 0
  overflow-x: auto
  position: relative
  white-space: nowrap
  width: 100%
  -webkit-overflow-scrolling: touch
  & > *
    transform: translate3d(0, 0, 0)
  th
    color: $mutedColor
    font-size: 12px
    padding: 16px 10px 8px 10px
    text-align: left
    &.amount-col-header
      text-align: right
    &.date-col-header
      text-align: right
    &.product-col-header
      width: 100%
  tr
    td
      border-top: 1px solid #eee
      padding: 10px
      &.status-col
        text-transform: uppercase
        text-align: center
      &.amount
        font-weight: 500
        text-align: right
        text-transform: uppercase
      &.date
        text-transform: capitalize
        text-align: right
      span.last4
        padding-left: 10px
    &:hover, &.open
      td:not(.transactionInfo)
        cursor: pointer
        background-color: rgba($mutedColor, .05)
</style>
